import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../utills/axiosInstance";
import "./adminHeader.css";
import { usePermissions } from "../utills/usePermissions";

const AdminHeader = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [data, setData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('data') || '{}');
    } catch {
      return {};
    }
  });
  const [expandedSections, setExpandedSections] = useState({
    organization: false,
    attendancePayroll: false,
    policies: false,
    performance: false,
    attendance: false,
    payroll: false,
    offboarding: false
  });

  const { hasPermission, loading } = usePermissions();

  useEffect(() => {
    const interval = setInterval(() => {
      const profile = JSON.parse(localStorage.getItem('profile') || '{}');
      const loacalData = JSON.parse(localStorage.getItem('data') || '{}');
  
      if (profile.displayName) {
        setUserName(profile.displayName || '');
      }
      if (Object.keys(loacalData).length > 0) {
        setData(loacalData);
      }
      if (profile.displayName && Object.keys(loacalData).length > 0) {
        clearInterval(interval);
      }
    }, 200);
  
    const initialProfile = JSON.parse(localStorage.getItem('profile') || '{}');
    const initialData = JSON.parse(localStorage.getItem('data') || '{}');
    if (initialProfile.displayName) setUserName(initialProfile.displayName);
    setData(initialData);
  
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    const profile = JSON.parse(localStorage.getItem('profile') || '{}');
    const idToken = data.id_token;
    const userHash = profile.id;
    const tenantId = process.env.REACT_APP_TENANT_ID;
    const postLogoutRedirectUri = encodeURIComponent(`${window.location.origin}`);
    const logoutUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/logout` +
      `?id_token_hint=${encodeURIComponent(idToken)}` +
      `&post_logout_redirect_uri=${postLogoutRedirectUri}`;

    axiosInstance.post('/auth/logout', { id_token: idToken, hash: userHash })
      .catch((err) => console.error('Server-side logout failed', err));

    localStorage.clear();
    window.location.href = logoutUrl;
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  if (!token) {
    return null;
  }

  const scopeGroups = {
    dashboard: ['dashboard:view'],
    organization: [
      'department:view', 'department:create', 'department:edit',
      'designation:view', 'designation:create', 'designation:edit',
      'employee:view', 'employee:create', 'employee:update', 'employee:delete', 'candidate:create'
    ],
    attendance: [
      'attendance:create', 'od:view', 'od:review', 'od:approve', 'od:reject',
      'attendance:viewAll', 'leaveBalance:view', 'leave:apply', 'leave:view',
      'leave:review', 'leave:approve', 'leave:reject'
    ],
    payroll: [
      'payroll:view', 'payrollComponents:view','payrollComponents:create', 'payrollComponents:update', 'payrollComponents:activate',
      'payrollPackage:configure', 'payRun:create', 'payRun:process', 'paySlip:download'
    ],
    policies: ['leavePolicy:view', 'leavePolicy:create', 'leavePolicy:update'],
    performance: ['performance:view'],
    templates: ['template:create', 'template:preview'],
    roleManagement: ['role:view', 'role:create', 'role:edit'],
    offboarding: [
      'offboarding:create', 'offboarding:view', 'offboarding:approveRM', 'offboarding:approveAdmin'
    ]
  };

  const orgDeptScopes = ['department:view', 'department:create', 'department:edit', 'designation:view', 'designation:create', 'designation:edit'];
  const orgEmployeeScopes = ['employee:view', 'employee:create', 'employee:update', 'employee:delete'];

  const attendanceReportScope = 'attendance:create';
  const myOdScope = 'od:view';
  const odScope = 'od:review';
  const allEmployeeReportScope = 'attendance:viewAll';
  const leaveBalanceScope = 'leaveBalance:view';
  const applyLeaveScope = 'leave:apply';
  const myLeaveRequestScope = 'leave:view';
  const allLeaveRequestScope = 'leave:review';

  const payrollDashboardScope = 'payroll:view';
  const payrollComponentsScopes = ['payrollComponents:view', 'payrollComponents:create', 'payrollComponents:update', 'payrollComponents:activate'];
  const payrollPackageScope = 'payrollPackage:configure';
  const payRunScope = 'payRun:create';
  const paySlipScope = 'paySlip:download';

  const leavePolicyScope = 'leavePolicy:view';

  const performanceScope = 'performance:view';

  const offboardingScope = 'offboarding:create';
  const myOffboardingScope = 'offboarding:view';
  const rmApprovalScope = 'offboarding:approveRM';
  const adminApprovalScope = 'offboarding:approveAdmin';

  return (
    <aside className="sidebar">
      {
        !loading && ( 
          <>
            <div className="sidebar-brand">
              <Link to="/dashboard">
                <strong>Marsforce</strong>
              </Link>
            </div>
            <nav className="sidebar-nav">
              <ul className="nav-list">
                {hasPermission(scopeGroups.dashboard) && (
                  <li className="section">
                    <Link to="/dashboard" className="nav-link-dashboard section-header">
                      Dashboard
                    </Link>
                  </li>
                )}
                {hasPermission(scopeGroups.organization) && (
                  <li className="section">
                    <div
                      className="section-header"
                      onClick={() => toggleSection('organization')}
                    >
                      Organization
                      <span className={`chevron ${expandedSections.organization ? 'expanded' : ''}`}>▼</span>
                    </div>
                    <ul className={`section-sub-list ${expandedSections.organization ? 'expanded' : 'collapsed'}`}>
                      {hasPermission(orgDeptScopes) && (
                        <li className="nav-item">
                          <Link to="/department" className="nav-link">
                            Departments and Designations
                          </Link>
                        </li>
                      )}
                      {hasPermission(orgEmployeeScopes) && (
                        <li className="nav-item">
                          <Link to="/employeedata" className="nav-link">
                            Employee Data
                          </Link>
                        </li>
                      )}
                      {data?.scopes?.includes('candidate:create') && (
                        <li className="nav-item">
                          <Link to="/candidatedata" className="nav-link">
                            Candidate Onboarding Data
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {hasPermission([...scopeGroups.attendance, ...scopeGroups.payroll]) && (
                  <li className="section">
                    <div
                      className="section-header"
                      onClick={() => toggleSection('attendancePayroll')}
                    >
                      Attendance and Payroll
                      <span className={`chevron ${expandedSections.attendancePayroll ? 'expanded' : ''}`}>▼</span>
                    </div>
                    <ul className={`section-sub-list ${expandedSections.attendancePayroll ? 'expanded' : 'collapsed'}`}>
                      {hasPermission(scopeGroups.attendance) && (
                        <li className="subsection">
                          <div
                            className="subsection-header"
                            onClick={() => toggleSection('attendance')}
                          >
                            Attendance
                            <span className={`chevron ${expandedSections.attendance ? 'expanded' : ''}`}>▼</span>
                          </div>
                          <ul className={`section-sub-list ${expandedSections.attendance ? 'expanded' : 'collapsed'}`}>
                            {data?.scopes?.includes(attendanceReportScope) && (
                              <li className="nav-item">
                                <Link to="/attendance" className="nav-link">
                                  My Attendance report
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(myOdScope) && (
                              <li className="nav-item">
                                <Link to="/my-od" className="nav-link">
                                  My On Duty
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(odScope) && (
                              <li className="nav-item">
                                <Link to="/od" className="nav-link">
                                  On Duty
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(allEmployeeReportScope) && (
                              <li className="nav-item">
                                <Link to="/all-employee-attendance" className="nav-link">
                                  All Employee report
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(leaveBalanceScope) && (
                              <li className="nav-item">
                                <Link to="/leavebalance" className="nav-link">
                                  Leave Balance
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(applyLeaveScope) && (
                              <li className="nav-item">
                                <Link to="/applyleave" className="nav-link">
                                  Apply Leave
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(myLeaveRequestScope) && (
                              <li className="nav-item">
                                <Link to="/leaverequest" className="nav-link">
                                  My Leave Request
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(allLeaveRequestScope) && (
                              <li className="nav-item">
                                <Link to="/leaveapproval" className="nav-link">
                                  All Leave Request
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                      {hasPermission(scopeGroups.payroll) && (
                        <li className="subsection">
                          <div
                            className="subsection-header"
                            onClick={() => toggleSection('payroll')}
                          >
                            Payroll
                            <span className={`chevron ${expandedSections.payroll ? 'expanded' : ''}`}>▼</span>
                          </div>
                          <ul className={`section-sub-list ${expandedSections.payroll ? 'expanded' : 'collapsed'}`}>
                            {data?.scopes?.includes(payrollDashboardScope) && (
                              <li className="nav-item">
                                <Link to="/payrolldashboard" className="nav-link">
                                  Payroll Dashboard
                                </Link>
                              </li>
                            )}
                            {hasPermission(payrollComponentsScopes) && (
                              <li className="nav-item">
                                <Link to="/payrollcomponents" className="nav-link">
                                  Payroll Components
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(payrollPackageScope) && (
                              <li className="nav-item">
                                <Link to="/payrollpackage" className="nav-link">
                                  Payroll Package
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(payRunScope) && (
                              <li className="nav-item">
                                <Link to="/payrollpayrun" className="nav-link">
                                  Pay Run
                                </Link>
                              </li>
                            )}
                            {data?.scopes?.includes(paySlipScope) && (
                              <li className="nav-item">
                                <Link to="/payrollslip" className="nav-link">
                                  Pay Slip
                                </Link>
                              </li>
                            )}
                          </ul>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {hasPermission(scopeGroups.policies) && (
                  <li className="section">
                    <div
                      className="section-header"
                      onClick={() => toggleSection('policies')}
                    >
                      Policies
                      <span className={`chevron ${expandedSections.policies ? 'expanded' : ''}`}>▼</span>
                    </div>
                    <ul className={`section-sub-list ${expandedSections.policies ? 'expanded' : 'collapsed'}`}>
                      {data?.scopes?.includes(leavePolicyScope) && (
                        <li className="nav-item">
                          <Link to="/leavepolicy" className="nav-link">
                            Leave Policy
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {hasPermission(scopeGroups.performance) && (
                  <li className="section">
                    <div
                      className="section-header"
                      onClick={() => toggleSection('performance')}
                    >
                      Performance Management
                      <span className={`chevron ${expandedSections.performance ? 'expanded' : ''}`}>▼</span>
                    </div>
                    <ul className={`section-sub-list ${expandedSections.performance ? 'expanded' : 'collapsed'}`}>
                      {data?.scopes?.includes(performanceScope) && (
                        <li className="nav-item">
                          <Link to="/performance" className="nav-link">
                            Performance Management
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {hasPermission(scopeGroups.templates) && (
                  <li className="section">
                    <Link to="/templates" className="nav-link-dashboard section-header">
                      Templates
                    </Link>
                  </li>
                )}
                {hasPermission(scopeGroups.roleManagement) && (
                  <li className="section">
                    <Link to="/access-control" className="nav-link-dashboard section-header">
                      Role Management
                    </Link>
                  </li>
                )}
                {hasPermission(scopeGroups.offboarding) && (
                  <li className="section">
                    <div
                      className="section-header"
                      onClick={() => toggleSection('offboarding')}
                    >
                      Offboarding / Exit
                      <span className={`chevron ${expandedSections.offboarding ? 'expanded' : ''}`}>▼</span>
                    </div>
                    <ul className={`section-sub-list ${expandedSections.offboarding ? 'expanded' : 'collapsed'}`}>
                      {data?.scopes?.includes(offboardingScope) && (
                        <li className="nav-item">
                          <Link to="/offboarding" className="nav-link">
                            Offboarding
                          </Link>
                        </li>
                      )}
                      {data?.scopes?.includes(myOffboardingScope) && (
                        <li className="nav-item">
                          <Link to="/myoffboarding" className="nav-link">
                            My Request
                          </Link>
                        </li>
                      )}
                      {data?.scopes?.includes(rmApprovalScope) && (
                        <li className="nav-item">
                          <Link to="/rmapproval" className="nav-link">
                            Offboarding Request
                          </Link>
                        </li>
                      )}
                      {data?.scopes?.includes(adminApprovalScope) && (
                        <li className="nav-item">
                          <Link to="/adminapproval" className="nav-link">
                            All Request
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </nav>
            <div className="sidebar-footer">
              <div className="user-info">
                <h6 className="welcome-text">
                  Welcome, {userName || "User"}
                </h6>
                <div className="dropdown-menu">
                  <Link to="/" className="nav-link" onClick={handleLogout}>
                    Logout
                  </Link>
                  <Link to="/help" className="nav-link">
                    Help
                  </Link>
                </div>
              </div>
            </div>
          </>
        )
      }
    </aside>
  );
};

export default AdminHeader;
